"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var ui_blocks_1 = require("@hopin-team/ui-blocks");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");
var ui_symbols_1 = require("@hopin-team/ui-symbols");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var isClickable = ui_blocks_1.INTERACTIVE.isClickable, isSelected = ui_blocks_1.INTERACTIVE.isSelected;
var body = ui_blocks_1.TYPOGRAPHY.body;
// Sizes =======================================================================
var Sizes;
(function (Sizes) {
    Sizes[Sizes["tiny"] = 0.5] = "tiny";
    Sizes[Sizes["small"] = 1] = "small";
    Sizes[Sizes["medium"] = 1.5] = "medium";
    Sizes[Sizes["large"] = 2] = "large";
})(Sizes || (Sizes = {}));
var makeSizeStyles = function (size, theme) {
    var _a;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: ", " 0.75rem;\n"], ["\n  padding: ", " 0.75rem;\n"])), (0, ui_symbols_1.calcSpace)(Sizes[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP, -1));
};
// * Height compensates for 1px / 0.0625rem borders.
// Patterns ====================================================================
var Patterns;
(function (Patterns) {
    Patterns["primary"] = "ACTION";
    Patterns["success"] = "SUCCESS";
    Patterns["danger"] = "ERROR";
    Patterns["warning"] = "WARN";
})(Patterns || (Patterns = {}));
var PatternHues;
(function (PatternHues) {
    PatternHues["primary"] = "BLUE";
    PatternHues["success"] = "GREEN";
    PatternHues["danger"] = "RED";
    PatternHues["warning"] = "YELLOW";
})(PatternHues || (PatternHues = {}));
var makePatternStyles = function (pattern, theme) {
    if (pattern in Patterns) {
        return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      color: ", ";\n      border: 0.0625rem solid\n        ", ";\n      background-color: ", ";\n\n      &:hover {\n        color: ", ";\n        border: 0.0625rem solid\n          ", ";\n        background-color: ", ";\n      }\n\n      &[aria-pressed='true'] {\n        color: ", ";\n        border: 0.0625rem solid\n          ", ";\n        background-color: ", ";\n      }\n    "], ["\n      color: ", ";\n      border: 0.0625rem solid\n        ", ";\n      background-color: ", ";\n\n      &:hover {\n        color: ", ";\n        border: 0.0625rem solid\n          ", ";\n        background-color: ", ";\n      }\n\n      &[aria-pressed='true'] {\n        color: ", ";\n        border: 0.0625rem solid\n          ", ";\n        background-color: ", ";\n      }\n    "])), function (_a) {
            var theme = _a.theme;
            return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.UTILITY.".concat(Patterns[pattern]), theme);
        }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternHues[pattern], "[\"100\"]"), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternHues[pattern], "[\"100\"]"), theme), function (_a) {
            var theme = _a.theme;
            return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.UTILITY.".concat(Patterns[pattern]), theme);
        }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternHues[pattern], "[\"100\"]"), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternHues[pattern], "[\"100\"]"), theme), function (_a) {
            var theme = _a.theme;
            return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.UTILITY.".concat(Patterns[pattern]), theme);
        }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternHues[pattern], "[\"300\"]"), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternHues[pattern], "[\"100\"]"), theme));
    }
    return '';
};
var Root = styled_components_1.default.button(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  border-radius: ", ";\n  color: ", ";\n  border: 0.0625rem solid\n    ", ";\n  background-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &[aria-pressed='true'] {\n    ", "\n    color: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  border-radius: ", ";\n  color: ", ";\n  border: 0.0625rem solid\n    ", ";\n  background-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &[aria-pressed='true'] {\n    ", "\n    color: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n  ", "\n"])), isClickable, body, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS_DEFAULT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["100"]', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["100"]', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["200"]', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["700"]', theme);
}, isSelected, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE["300"]', theme);
}, function (props) { return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'size', makeSizeStyles); }, function (props) { return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', makePatternStyles); });
exports.Root = Root;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=root.js.map